import gql from 'graphql-tag'
import { getApolloClient } from '@/lib/apollo-client'

/**
 * *(AI-generated)*
 * Fetches the fishing region guide ID matching the given feature URN identifiers.
 */
export const regionIdFromUrn = async (featureUrn: string[]) => {
  const guidesIdQuery = () => {
    return gql`
      query GuidesIdQuery($filter: GuideFilter) {
        guides(filter: $filter) {
          id
          __typename
          name
        }
      }
    `
  }
  const filter = {
    filter: {
      identifiers: {
        intersects: featureUrn,
      },
      typenames: ['FishingRegion'],
    },
  }
  const client = getApolloClient()
  const response = await client.query({
    query: guidesIdQuery(),
    variables: filter,
  })
  const guide = response.data?.guides?.[0]
  return guide
}

/**
 * *(AI-generated)*
 * Fetches the fishing area ID and its waterbody reference matching the given feature URN identifiers.
 */
export const fishingAreaIdFromUrn = async (featureUrn: string[]) => {
  const fishingAreaQuery = () => {
    return gql`
      query FishingAreaById($filter: FishingAreaFilter) {
        fishingAreas(filter: $filter) {
          id
          waterbody {
            __typename
            id
          }
        }
      }
    `
  }
  const filter = {
    filter: {
      identifiers: {
        intersects: featureUrn,
      },
    },
  }
  const client = getApolloClient()
  const response = await client.query({
    query: fishingAreaQuery(),
    variables: filter,
  })
  const area = response.data?.fishingAreas?.[0]
  return area
}
